module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';
	fox.registerWidget('Popup_Delete', {
		
		configure: function(options) {
			this.registerOptions('', {
				autoRender: true,
				template: 'popup_confirmation',
				customApiParams: false,
				widgets: {
					deleteApi: {
						widget: 'Api',
						method: 'liveshow.delete',
						sendTimezone: true,
						httpMethod: 'post'
					}
				},
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this
				.setOption('handleDom.confirmAction_' + this._parentId, {
					targetWidget: '@parent',
					target: '#p-apply',
					event: 'click',
					callback: 'confirmAction'
				})
				.setOption('handleDom.cancelAction_' + this._parentId, {
					targetWidget: '@parent',
					target: '#p-cancel',
					event: 'click',
					callback: '@parent:hide'
				});

			this.callParent('init', arguments);
		},

		setContentId: function(id) {
			this.contentId = id;
		},
		
		running: function() {
			this.templateOptions.message = this.options.message;
			this.popup = this.getParent();
		},

		confirmAction: function() {
			var api = this.rwom1('#deleteApi').setOption('method', this.getOption('method'));
			this.handleEvent(api, 'success', fox.bind(function(data) {
				if (this.options.onSuccess) {
					this.options.onSuccess(data.answer.response);
				}

				var optionsOnSuccess = this.options.onSuccess ? this.options.onSuccess(data.answer.response) : '';

				this.cancel();

				this.dispatchEvent('success');
			}, this));
			this.handleEvent(api, 'failure', this.cancel);

			if (this.getOption('customApiParams')) {
				this.hookWrapper('confirmDeleting', api);

				return;
			}

			api.send({id: this.contentId}, false);

			return false;
		},

		cancel: function() {
			this.popup.hide();
			this._indom = false;

		}
	});

})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/popup/delete.js
// module id = 342
// module chunks = 2